export const TOGGLE_SIDEBAR = 'TOGGLE_SIDEBAR';
export const SET_INITIAL_STATE = 'SET_INITIAL_STATE';
export const SET_PARTNER = 'SET_PARTNER';
export const LOGOUT = 'LOGOUT';
export const REFRESH_SESSION = 'REFRESH_SESSION';
export const SKIP_LOAD = 'SKIP_LOAD';
export const ROUTE_CHANGED = 'ROUTE_CHANGED';
export const TOGGLE_SIDEBAR_DEVICE = 'TOGGLE_SIDEBAR_DEVICE';
export const HANDLE_APP_LOAD = 'HANDLE_APP_LOAD';
export const SET_REFERRAL_DETAILS = 'SET_REFERRAL_DETAILS';
export const SET_VIEWPORT_DEVICE = 'SET_VIEWPORT_DEVICE';
export const HIDE_TOOLTIP = 'HIDE_TOOLTIP';
export const SET_APP_CONFIG = 'SET_APP_CONFIG';
export const RESET_STATE = 'RESET_STATE';
export const SET_FLIPPERS = 'SET_FLIPPERS';

export const resetState = () => ({
  type: RESET_STATE
});

export const setAppConfig = config => ({
  type: SET_APP_CONFIG,
  config
});
export const hideTooltip = () => ({
  type: HIDE_TOOLTIP
});
export const setReferralDetails = payload => ({
  type: SET_REFERRAL_DETAILS,
  payload
});
export const handleAppLoad = () => ({
  type: HANDLE_APP_LOAD
});
export const routeChanged = (from, to) => ({
  type: ROUTE_CHANGED,
  from,
  to
});
export const skipLoad = () => ({
  type: SKIP_LOAD
});
export const refreshSession = () => ({
  type: REFRESH_SESSION
});
export const logout = () => ({
  type: LOGOUT
});
export const setPartner = partner => ({
  type: SET_PARTNER,
  partner
});

export const setInitialState = payload => ({
  type: SET_INITIAL_STATE,
  payload
});
export const toggleSidebar = () => ({
  type: TOGGLE_SIDEBAR
});

export const toggleSidebarDevice = () => ({
  type: TOGGLE_SIDEBAR_DEVICE
});

export const setViewportDevice = viewportDevice => ({
  type: SET_VIEWPORT_DEVICE,
  viewportDevice
});

export const setFlippers = payload => ({
  type: SET_FLIPPERS,
  payload
});

const initialState = {
  // view state
  loading: true,
  sidebarOpened: true,
  sidebarOpenedDevice: false,
  config: {},
  flippers: {}
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SKIP_LOAD:
      return {
        ...state,
        loading: false
      };
    case SET_INITIAL_STATE:
      return {
        ...state,
        currencies: action.payload.currencies
      };
    case TOGGLE_SIDEBAR:
      return {
        ...state,
        sidebarOpened: !state.sidebarOpened
      };
    case TOGGLE_SIDEBAR_DEVICE:
      return {
        ...state,
        sidebarOpenedDevice: !state.sidebarOpenedDevice
      };
    case SET_PARTNER:
      return {
        ...state,
        partner: action.partner,
        loading: true
      };
    case LOGOUT:
      return {
        ...state,
        partner: undefined,
        referralDetails: undefined
      };
    case SET_REFERRAL_DETAILS:
      return {
        ...state,
        loading: false,
        referralDetails: action.payload
      };
    case SET_VIEWPORT_DEVICE:
      return {
        ...state,
        viewportDevice: action.viewportDevice
      };
    case ROUTE_CHANGED:
      return {
        ...state,
        sidebarOpenedDevice: false,
        routes: {
          from: action.from,
          to: action.to
        }
      };
    case SET_APP_CONFIG:
      return {
        ...state,
        config: action.config
      };
    case SET_FLIPPERS:
      return {
        ...state,
        flippers: action.payload.flippers
      };
    default:
      return state;
  }
};
